<template>
	<dropdown
		:id="id"
		:label="label"
		:button-class="['link-selector', extraButtonClass].join(' ')"
		container-class="dropdown-light"
		:aria-label="ariaLabel"
	>
		<template #label>
			<span v-if="selectedLink" class="align-middle">
				<i
					v-if="selectedLink.archived"
					class="af-icons af-icons-archived danger align-middle"
					:title="lang.get('miscellaneous.state.archived')"
				></i>
				{{ selectedLink.name }}
			</span>
			<span v-else>{{ lang.get('miscellaneous.loading') }}</span>
			<span class="caret"></span>
		</template>

		<li v-for="link in links" :key="link.link">
			<a :href="baseUrl + link.link" class="dropdown-menu-item">
				<i
					v-if="link.archived"
					class="af-icons af-icons-archived danger align-middle"
					:title="lang.get('miscellaneous.state.archived')"
				></i>
				<span>
					{{ link.name + (link.archived ? lang.get('form.archived') : '') }}
				</span>
			</a>
		</li>
	</dropdown>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { Dropdown } from 'vue-bootstrap';
import { trans } from '@/domain/dao/Translations';
import LinkSelector from '@/lib/components/Shared/LinkSelector';

export default defineComponent({
	name: 'FormSelector',
	extends: LinkSelector,
	components: {
		Dropdown,
	},

	// Props inherited from LinkSelector
	setup(props) {
		const parentSetup = LinkSelector.setup?.(props) || {};

		const selectedLink = computed(() => {
			const key = props.activeLink || props.links[0]?.link;
			return props.links.find((link) => link.link === key);
		});

		return {
			...parentSetup,
			selectedLink,
			lang: trans(),
		};
	},
});
</script>
